import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6112a6cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details" }
const _hoisted_2 = { class: "details-inner" }
const _hoisted_3 = {
  class: "label font-bold",
  "data-transition-enter": ""
}
const _hoisted_4 = {
  class: "description",
  "data-transition-enter": ""
}

import { computed, PropType, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import gsap from 'gsap'
import frames from '@/utils/FrameToTime'

import { useAppState } from '@/services/composition'
import { useGameState } from '@/services/composition'
import { Hotspot } from '@/services/stores/hotspots'



export default /*#__PURE__*/_defineComponent({
  props: {
  hotspot: {
    type: Object as PropType<Hotspot>,
    required: true
  }
},
  setup(__props) {

const props = __props

const state = useGameState()

const { t } = useI18n()
const { send } = useAppState()



const isSelected = computed(() => {
  return state.value.context.hotspotSelected === props.hotspot.id
})

const handleClick = () => {
  send({ type: 'GAME_HOTSPOT_SELECT', payload: !isSelected.value ? props.hotspot.id : -1 })
}

const handleAdvise = () => {
  send({ type: 'GAME_HOTSPOT_ADVISE', payload: props.hotspot.id })
}

const onEnter = (el: HTMLElement, onComplete: gsap.Callback) => {
  const $ = gsap.utils.selector(el)
  const tl = gsap.timeline({ onComplete })
  tl.fromTo(el, { yPercent: 100, }, {yPercent: 0, duration: frames(30), ease: 'quint.out' })
  tl.fromTo($('[data-transition-enter]'), { yPercent: 100, opacity: 0, }, {yPercent: 0, opacity: 1, duration: frames(30), ease: 'quint.out', stagger: 0.1 }, 0.2)
}

const onLeave = (el: HTMLElement, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })

  tl.to(el, { yPercent: 100, duration: frames(30), ease: 'quint.in' })
}


return (_ctx: any,_cache: any) => {
  const _component_ui_btn = _resolveComponent("ui-btn")!
  const _component_ui_btn_icon = _resolveComponent("ui-btn-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    css: false,
    onEnter: onEnter,
    onLeave: onLeave
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)(`hotspots.${__props.hotspot.name}.label`)), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(`hotspots.${__props.hotspot.name}.description`)), 1),
          _createVNode(_component_ui_btn, {
            class: "advise",
            onClick: handleAdvise,
            "data-transition-enter": ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('game.companion.advise')), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_ui_btn_icon, {
          class: "close",
          color: "dark",
          onClick: handleClick,
          name: "crossmark"
        })
      ])
    ]),
    _: 1
  }))
}
}

})